module.exports = __webpack_public_path__ + "img/2019051634btn_4_03.8838994d.png";